export default __webpack_public_path__ + "static/favicon-dc6eb9bd02c702a2152afcbca1f14bda.png";